// Preferences that must follow the visitor from getphuket.com to villas.,
// rentals., transfers., experiences. and the partner hosts (2026-09-07).
// localStorage is per origin, so a choice made on one host is invisible on
// the next; a cookie set for the registrable domain is shared by all of
// them. On localhost (the /_p preview) the cookie is host-only.
export function brandCookieDomain(host = window.location.hostname) {
  const m = String(host).match(/getphuket\.(com|ru|online)$/)
  return m ? `.getphuket.${m[1]}` : null
}

// A host-only cookie and a domain-wide one of the same name coexist and are
// both sent, so document.cookie can carry the name twice with different
// values. Taking the first would pick the host-only leftover about half the
// time — instead, disagreeing copies read as "no preference" and the next
// explicit choice settles it domain-wide. (Server side: BrandCookies.)
export function readCookie(name) {
  const values = document.cookie
    .split(';')
    .map((pair) => pair.trim())
    .filter((pair) => pair.slice(0, name.length + 1) === `${name}=`)
    .map((pair) => {
      try { return decodeURIComponent(pair.slice(name.length + 1)) } catch (e) { return pair.slice(name.length + 1) }
    })
  const unique = [...new Set(values)]
  return unique.length === 1 ? unique[0] : null
}

export function setBrandCookie(name, value, days = 365) {
  const domain = brandCookieDomain()
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${days * 86400}; SameSite=Lax${domain ? '; domain=' + domain : ''}${secure}`
}
